import { createFileRoute, Outlet } from '@tanstack/react-router';
import BasicLayout from 'src/components/layout/BasicLayout';
import NotFoundContent from 'src/components/layout/NotFoundContent';

export const Route = createFileRoute('/_authenticated/_layout-basic')({
  component: () => {
    return (
      <BasicLayout>
        <Outlet />
      </BasicLayout>
    );
  },
  notFoundComponent: () => <NotFoundContent className="mt-2" />,
});
